import { Environment } from '@/constants/common';
import { getAnalyticsEnvironment } from '@/utils/environment';
import type { SegmentClientName } from '@/typings/segment-manager';

export const bookingSegmentKeys = {
  [Environment.Production]: 'FpDX2n8R3TNNHhwBWDo94JCjGGQGkZVt',
  [Environment.Stage]: 'pGyW7G2koNsBoOnJapGFTQbkEdJOiEsX',
  [Environment.Dukenukem]: '8uhbAbNjyVuWOwF7afcYPjwLbDokUX2J',
  [Environment.Development]: 'E1yCGAvBtCOCF3tFKF6woJXhMh7gM58Z'
} as const;

export const websiteSegmentKeys = {
  [Environment.Production]: 'MvqIdLLohejARkJcUe7Ze60ERxfMTqwV',
  [Environment.Stage]: 'Lq4BoLISiSOhu8UbGHS4Bj9eRWlM8uaJ',
  [Environment.Dukenukem]: 'AEsgpdDAuoFmRpHIRTvHtQ2VejF4sxew',
  [Environment.Development]: 'fb5S8qJrpE7yXhpaCNBCG89dtSi03Mdh'
} as const;

export function getSegmentKey(name: SegmentClientName = 'booking'): string {
  const environment = getAnalyticsEnvironment();
  const keys = name === 'website' ? websiteSegmentKeys : bookingSegmentKeys;

  return keys[environment];
}
